export default "__VITE_ASSET__CYl7f_bl__"